module.exports = __webpack_public_path__ + "files/c2274181591097b8ec68e8c0f86b0770.png";